module.exports = __webpack_public_path__ + "static/img/4011.bbacf40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4011.png
// module id = 718
// module chunks = 0 1 12